module.exports = __webpack_public_path__ + "static/media/alert.30ef7683.svg";